// Branded placeholder art for entities without an uploaded photo (Phase 4).
// Deterministic: the slug always hashes to the same variant — same system as
// masjidPlaceholder. Sets exist for business, event, article and campaign.

const VARIANTS = ['emerald', 'gold', 'navy', 'teal', 'sand', 'midnight'] as const
type Entity = 'business' | 'event' | 'article' | 'campaign'

function variantFor(slug: string | null | undefined): string {
  const s = slug || 'entity'
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0
  return VARIANTS[h % VARIANTS.length]
}

export function entityPlaceholder(entity: Entity, slug: string | null | undefined): string {
  return `/placeholders/${entity}-${variantFor(slug)}.svg`
}

export const businessPlaceholder = (slug: string | null | undefined) => entityPlaceholder('business', slug)
export const eventPlaceholder = (slug: string | null | undefined) => entityPlaceholder('event', slug)
export const articlePlaceholder = (slug: string | null | undefined) => entityPlaceholder('article', slug)
export const campaignPlaceholder = (slug: string | null | undefined) => entityPlaceholder('campaign', slug)
